import { getCurrentProfileSelect } from '../get-current'
import { createSelector } from 'reselect'
import isAdminProfileUtil from '../../../../../models/profile/utils/is-admin'

const isAdminProfileSelect = createSelector(getCurrentProfileSelect,
  (profile) => isAdminProfileUtil(profile)
)

export default isAdminProfileSelect
